// @material-ui
import { makeStyles } from '@material-ui/styles'

const maxDescriptionLines = 3

export const productListItemDetailsStyle = theme => ({
  root: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
  },

  media: {
    minHeight: theme.spacing(20),
  },

  content: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
  },

  title: {},

  desciption: {
    overflow: 'hidden',
    position: 'relative',
    maxHeight: `calc(${maxDescriptionLines} * ${theme.typography.body2.lineHeight} * ${theme.typography.body2.fontSize})`,
    lineClamp: maxDescriptionLines,
    boxOrient: 'vertical',
    textOverflow: 'ellipsis',
    flexGrow: 1,

    '& strong': {
      fontWeight: theme.typography.fontWeightBold,
    },
  },
})

export const useProductListItemDetailsStyle = makeStyles(
  productListItemDetailsStyle
)
